import { Group, Modal, type ModalProps } from '@mantine/core'
import type { ReactNode } from 'react'

export type AppModalProps = Omit<ModalProps, 'title'> & {
  opened: boolean
  onClose: () => void
  title?: ReactNode
  /** Основное содержимое */
  children: ReactNode
  /** Нижняя панель (кнопки) */
  footer?: ReactNode
  /** Выравнивание футера */
  footerJustify?: 'flex-start' | 'center' | 'flex-end' | 'space-between'
}

/**
 * Обёртка над Mantine Modal: заголовок, тело и опциональный футер.
 * Для подтверждений удобнее `confirmDialog` / `openConfirmModal` из `@/lib/confirm`.
 */
export function AppModal({
  opened,
  onClose,
  title,
  children,
  footer,
  footerJustify = 'flex-end',
  centered = true,
  ...modalProps
}: AppModalProps) {
  return (
    <Modal opened={opened} onClose={onClose} title={title} centered={centered} {...modalProps}>
      {children}
      {footer ? (
        <Group justify={footerJustify} mt="lg" gap="sm" wrap="wrap">
          {footer}
        </Group>
      ) : null}
    </Modal>
  )
}
